import logo from './logo.svg';
import './App.scss';
import react from 'react';
import Nav from './components/Nav';
import Main from './components/Main';


// function App ()=>{} previous code
// this makes it consistent with the other js files
const App = () => {
  return (
    <div className="outerWrap">
    <div className="App">
      {/* this is rendering d components */}
      <Nav />
      <Main />

    </div>
    <div className="musicControls">music controls</div>
    </div>
  );
}

export default App;
